/**
 * Compact nav breakpoint — marketing hamburger menu and viewer handheld chrome.
 * Keep CSS `@media` rules and `matchMedia` checks aligned with these values.
 */
export const COMPACT_NAV_MAX_WIDTH_PX = 980;

export const COMPACT_NAV_MEDIA_QUERY = `(max-width: ${COMPACT_NAV_MAX_WIDTH_PX}px)`;

export const COMPACT_NAV_DESKTOP_MEDIA_QUERY = `(min-width: ${COMPACT_NAV_MAX_WIDTH_PX + 1}px)`;

/** Narrow container padding — marketing `.container` horizontal inset. */
export const NARROW_CONTAINER_MAX_WIDTH_PX = 720;

export const NARROW_CONTAINER_MEDIA_QUERY = `(max-width: ${NARROW_CONTAINER_MAX_WIDTH_PX}px)`;
